module.exports = __webpack_public_path__ + "img/2.11837450.png";